import { Container } from "@mantine/core";
import type { CustomLayout } from "next";
import { FooterMenu } from "src/layout/AppLayout/FooterMenu";
import { PageMain } from "src/layout/AppLayout/PageMain";

import { LayoutErrorBoundary } from "../LayoutErrorBoundary";
import styles from "./AppLayout.module.scss";
import { Header } from "./Header";

export const AppLayout: CustomLayout = (page) => {
  return (
    <div className={styles.layout}>
      <Header />
      <LayoutErrorBoundary>
        <Container className={styles.inner}>
          <PageMain page={page} />
        </Container>
      </LayoutErrorBoundary>
      <FooterMenu />
    </div>
  );
};
